'use client';

import styles from './policy.module.css';
import Head from "next/head";

export default function TermsOfServicePage() {

  return (


    <div className={styles.pageWrapper}>
      <h1 className={styles.title}>Terms of Service</h1>
      <p className={styles.updated}>Last updated: October 2025</p>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Acceptance of Terms</h2>
        <p className={styles.sectionText}>
          By using <strong>Mira Classic</strong>, you agree to these Terms of Service. If you do not agree, please discontinue use.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>2. User Accounts</h2>
        <p className={styles.sectionText}>
          You are responsible for maintaining the confidentiality of your account and for all activities under it.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Use of Service</h2>
        <p className={styles.sectionText}>
          You agree not to misuse the service, attempt unauthorized access, or infringe on intellectual property rights.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Content Ownership</h2>
        <p className={styles.sectionText}>
          All content provided remains the property of its respective owners. You may not redistribute or resell without permission.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Termination</h2>
        <p className={styles.sectionText}>
          We reserve the right to suspend or terminate accounts that violate these terms.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>6. Privacy & Data Protection</h2>
        <p className={styles.sectionText}>
          Your use of Mira Classic is also governed by our <a href="/privacy" className={styles.link}>Privacy Policy</a>.
          By using the service, you acknowledge that your personal data is processed as described there.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>7. Limitation of Liability</h2>
        <p className={styles.sectionText}>
          Mira Classic is provided &quot;as is&quot; without warranties of any kind.
          We are not liable for indirect, incidental, or consequential damages arising from your use of the service.
        </p>
        <p className={styles.sectionText}>
          We may update these Terms of Service from time to time to reflect changes in technology, legal requirements, or our services.
          The &quot;Last updated&quot; date will always indicate the latest revision.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>8. Changes to Terms</h2>
        <p className={styles.sectionText}>
          We may update these Terms of Service from time to time to reflect changes in technology, legal requirements, or our services.
          The &quot;Last updated&quot; date will always indicate the latest revision.
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>9. Governing Law</h2>
        <p className={styles.sectionText}>
          These Terms of Service are governed by applicable laws and regulations.
          Any disputes shall be subject to the jurisdiction of the competent courts.
        </p>
      </div>
    </div>

  );
}
